import script from "./MenuCards.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuCards.vue?vue&type=script&setup=true&lang=js"

import "./MenuCards.vue?vue&type=style&index=0&id=28b99194&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28b99194"]])

export default __exports__